import { createFileRoute } from '@tanstack/react-router';
import { redirectToHealthReadiness } from '@/components/health-readiness/legacy-redirect';

/**
 * The old Go-Live Readiness → Criteria (T-0224, T-0242): lands on the Go-live
 * criteria tab at its first criterion, whose detail carries its score,
 * evidence and cross-module references.
 */
export const Route = createFileRoute('/engagements/$engagementId/golive/criteria')({
  beforeLoad: ({ params }) => {
    throw redirectToHealthReadiness(params.engagementId, { tab: 'criteria' });
  },
});
